import BasePopupHandler from './BasePopupHandler';
import GameObject from '../../../GameObject/GameObject';
import UIItem, { ITextData } from '../../../Prototype/UI/UIItem';
import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import { Native } from '@sgorg/mobile-dev-tools';
import { PopupID } from '../../../State/UI/PopupID';
import UITextComponent from 'Component/UI/Text';

export default class ProgressionPassedMobileVersion extends BasePopupHandler {
    private readonly yourCurrentLevel: string = "YourCurrentLevel"
    private readonly latestAvailableLevel: string = "LatestAvailableLevel"
    private completedLevel: number = 0;
    private gameLevelLimit: number = 0;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.PROGRESSION_PASSED_MOBILE_VERSION, uiSystem);
    }

    public createPopup(params?: any) {
        this.submitBtnParams.text.textLocalizationKey = 'ToFacebook';
        this.submitBtnParams.text.style = this.getSubmitStyle();
        this.submitBtnParams.button.cacheKey = 'button_medium_blue'
        this.submitBtnParams.onClick = () => Native.main.openUrl('https://www.facebook.com/instantgames/2258990194419804/');

        super.createPopup({
            buttons: [
                this.submitBtnParams,
            ],
            title: 'Important',
        });

        this.createMainInfo();
    }

    public onShow(params: {completedLevel: number, gameLevelLimit: number}) {
        this.completedLevel = params.completedLevel;
        this.gameLevelLimit = params.gameLevelLimit;

        this.background.findChildByName(this.yourCurrentLevel)
            .getComponent(UITextComponent).text =  Game.locale.getText('YourCurrentLevel')
            .replace('[x]', `${this.completedLevel}`);

        this.background.findChildByName(this.latestAvailableLevel)
            .getComponent(UITextComponent).text = Game.locale.getText('LatestAvailableLevel')
            .replace('[x]', `${this.gameLevelLimit}`);
    }

    private createMainInfo(): void {
        const title1: GameObject<PIXI.Container> = UIItem.createText(this.titleTxt1);
        const title2: GameObject<PIXI.Container> = UIItem.createText(this.titleTxt2);
        const currentLevel: GameObject<PIXI.Container> = UIItem.createText(this.currentLevel);
        const latestLevel: GameObject<PIXI.Container> = UIItem.createText(this.highestLevel);

        this.background.addChild(title1);
        this.background.addChild(title2);
        this.background.addChild(currentLevel);
        this.background.addChild(latestLevel);
    }

    protected titleTxt1: ITextData = {
        name: 'progressTxt1',
        textLocalizationKey: 'ProgressToFarText1',
        layout: {
            anchors: [0.5, 0.125, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#8b3130',
            fontSize: '31px',
        },
        bounds: [650, 400],
        wordWrap: true,
        wordWrapWidth: 650
    };

    protected titleTxt2: ITextData = {
        name: 'progressTxt2',
        textLocalizationKey: 'ProgressToFarText2',
        layout: {
            anchors: [0.5, 0.55, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#8b3130',
            fontSize: '31px',
        },
        bounds: [650, 400],
        wordWrap: true,
        wordWrapWidth: 650,
    };

    protected currentLevel: ITextData = {
        name: this.yourCurrentLevel,
        layout: {
            anchors: [0.5, 0.875, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#FFFFFF',
            stroke: '#8b3130',
            fontSize: '31px',
            strokeThickness: 8,
            lineJoin: 'round',
        },
    };

    protected highestLevel: ITextData = {
        name: this.latestAvailableLevel,
        layout: {
            anchors: [0.5, 1.025, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#FFFFFF',
            stroke: '#8b3130',
            fontSize: '32px',
            strokeThickness: 8,
            lineJoin: 'round',
        },
    };

    private getSubmitStyle() {
        return {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '50px',
            stroke: '#284E93',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        };
    }

    protected titleParams: ITextData = {
        name: 'popup_title',
        text: 'Title',
        style: {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '45px',
            stroke: '#ab3143',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        },
        layout: {
            anchors: [0.5, 0.45, 0.5, 0.45],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        bounds: [460, 240],
    };
}
